// src/constants/branding.js
//
// Single source of truth for the application display name.
// To rename the app, change APP_NAME here — nowhere else.

export const APP_NAME = "Places Dashboard";
